import { useAppDispatch } from '../../store/react_redux_typed';
import { fetchUsersByQuery } from '../../utils/filters/fetch_users_by_query';
import { useSearchableFilterOptions } from './use_searchable_filter_options';

export function useUserFilterOptions(selectedKeys: string[]) {
  const dispatch = useAppDispatch();

  return useSearchableFilterOptions(
    (query) => fetchUsersByQuery(query, dispatch),
    selectedKeys,
  );
}
